/**
 * External store for tracking whether the chat app window is open.
 * Used to bridge WindowManager (deep in provider tree) with
 * ChatWebSocketProvider (higher in provider tree) without
 * requiring provider reordering.
 *
 * Compatible with React's useSyncExternalStore.
 */

let _isActive = false;
const _listeners = new Set<() => void>();

export const chatActiveStore = {
    getSnapshot: () => _isActive,

    subscribe: (listener: () => void) => {
        _listeners.add(listener);
        return () => {
            _listeners.delete(listener);
        };
    },

    setActive: (value: boolean) => {
        if (_isActive !== value) {
            _isActive = value;
            _listeners.forEach((l) => l());
        }
    },
};
